/* eslint-disable react-hooks/exhaustive-deps */
import AppLoader from "../Components/Loader/AppLoader";
import ConfirmationNotification from "../Components/ConfirmationNotification";
// import ReactGa from "react-ga";
import "../i18n";

import { connect } from "react-redux";
import { useEffect } from "react";
import { OptimeRouter } from "./Routes";
import { ThemeProviders } from "./Providers";
import { useTranslation } from "react-i18next";
import { SnackbarProvider } from "notistack";
import { GetStorage, RemoveStorage } from "../Utils/Storage";
import { getMissionConfirmationAction } from "../Store/Actions/PlanView/Actions";
import {
  userMustLoginAction,
  toggleLoadingAction,
  getCurrentUserAction,
} from "../Store/Actions/Auth/Actions";
import { BrowserRouter as Router } from "react-router-dom";
import RHToast from "../Components/CustomNotification/RHToast";
// import posthog from "posthog-js";

function Optime(props) {
  // { process.env.REACT_APP_ENV === "production" && ReactGa?.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS); }

  // { process.env.REACT_APP_ENV === "production" && ReactGa?.pageview(window.location.pathname + window.location.search); }

  const getCurrentUserInfo = () => {
    props.toggleLoading(true);
    props.getCurrentUser();
    props.getMissionConfirmation();
    props.toggleLoading(false);
  };

  // Identify a user after login or other criteria
  // const identifyUser = () => {
  //   const userProperties = {
  //     url: process.env.REACT_APP_API_BASE_URL,
  //     orgId: props.User?.sessionOrganizationId,
  //     tenantId: props.User?.sessionTenantId,
  //     userName: props.User?.userName,
  //   };

  //   posthog.identify(props.User?.userName, userProperties);
  // };

  const { i18n } = useTranslation();

  useEffect(() => {
    // handleAPIConnection();
    if (GetStorage("optime_token")) {
      getCurrentUserInfo();
    }
  }, []);

  useEffect(() => {
    if (props.User) {
      // identifyUser();
    }
  }, [props.User]);

  useEffect(() => {
    // Redirect user to login page
    if (props.MustLogin) {
      RemoveStorage("optime_token");
      if (props.UserRole === "SUPERADMIN") {
        window.location.href =
          window.location.origin + "/optime-admin/couper-atmin/login";
      } else if (
        props.UserRole === "ORGANIZATIONMANAGER" ||
        props.UserRole === "ORGANIZATIONVIEWER"
      ) {
        window.location.href =
          window.location.origin + "/organization-manager/login";
      } else {
        window.location.href = window.location.origin + "/login";
      }
    }
  }, [props.UserRole, props.MustLogin]);

  return (
    <ThemeProviders>
      {props.getLoadingState ? (
        <AppLoader message="Loading OptimeAI Dashboard" />
      ) : (
        <SnackbarProvider preventDuplicate maxSnack={3}>
          <Router>

            {/* submit mission status by Dispatcher */}
            {props.confirmationRequestEnabled && !props.getLoadingState && (
              <ConfirmationNotification />
            )}
            
            <OptimeRouter UserRole={props.UserRole} />
            <div style={{ direction: i18n.dir() }} id="snackbarHelper"></div>
            <RHToast />
          </Router>
        </SnackbarProvider>
      )}
    </ThemeProviders>
  );
}

const mapStateToProps = (state) => {
  return {
    UserRole: state.auth.UserRole,
    User: state.auth.User?.response,
    MustLogin: state.auth.MustLogin,
    getLoadingState: state.auth.IsLoading,
    confirmationRequestEnabled:
      state.auth.User?.response?.confirmationRequestEnabled,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCurrentUser: () => dispatch(getCurrentUserAction()),
    userMustLogin: (state) => dispatch(userMustLoginAction(state)),
    getMissionConfirmation: () => dispatch(getMissionConfirmationAction()),
    toggleLoading: (shouldLoading = false) =>
      dispatch(toggleLoadingAction(shouldLoading)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Optime);
